import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'audience-drawer' }

import { ref, watch, onBeforeUnmount, getCurrentInstance, type PropType } from 'vue'
import axios from 'axios'
import { Auth } from 'aws-amplify'
import { API_LOCATION } from '@/api-config'
import CustomerFilterPanel from '@/components/CustomerFilterPanel.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  show: { type: Boolean, default: false },
  audience: { type: Object as PropType<any>, default: null },
  games: { type: Array as PropType<any[]>, default: () => [] },
  scopedGroupIds: { type: Array as PropType<number[] | null>, default: null }
},
  emits: ['update:show', 'close', 'saved'],
  setup(__props, { emit }) {

const props = __props





const { proxy } = getCurrentInstance() as any

const companyId = localStorage.getItem('companyId')
const companyGroupId = JSON.parse(localStorage.getItem('group') || '{}').id
const baseUrl = `${API_LOCATION}companies/${companyId}/groups/${companyGroupId}`

const name = ref('')
const filter = ref<Record<string, any>>({})
const saving = ref(false)

async function authConfig() {
  const session = await Auth.currentSession()
  return { headers: { Authorization: (session as any).idToken.jwtToken } }
}

function apiErrorMessage(err: any, fallback: string): string {
  const data = err?.response?.data
  if (data) {
    try {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data
      if (Array.isArray(parsed?.validation_errors) && parsed.validation_errors.length > 0) {
        return parsed.validation_errors[0].message
      }
      if (parsed?.error) return parsed.error
    } catch {
      if (typeof data === 'string' && data.length < 200) return data
    }
  }
  return fallback
}

function loadForm() {
  name.value = props.audience?.name || ''
  filter.value = { ...(props.audience?.filter_json || {}) }
}

async function save() {
  if (!props.audience) return
  if (!name.value.trim()) {
    proxy.$notify({ type: 'warning', message: 'Give the audience a name', icon: 'tim-icons icon-alert-circle-exc' })
    return
  }
  saving.value = true
  try {
    const config = await authConfig()
    const payload = { name: name.value.trim(), filter_json: filter.value }
    const response = await axios.put(`${baseUrl}/customer-audiences/${props.audience.id}`, payload, config)
    proxy.$notify({ type: 'success', message: 'Audience saved', icon: 'tim-icons icon-check-2' })
    // The server may clamp a restricted caller's filter to their groups; keep
    // the stored version so the list and the drawer show what was saved.
    emit('saved', { ...props.audience, name: payload.name, filter_json: response.data?.filter_json || payload.filter_json })
    emit('update:show', false)
    emit('close')
  } catch (err: any) {
    proxy.$notify({ type: 'danger', message: apiErrorMessage(err, 'The audience could not be saved'), icon: 'tim-icons icon-alert-circle-exc' })
  } finally {
    saving.value = false
  }
}

function onClose() {
  emit('update:show', false)
  emit('close')
}

function onEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape') onClose()
}

watch(() => props.show, (visible) => {
  if (visible) {
    document.addEventListener('keydown', onEscKey)
    loadForm()
  } else {
    document.removeEventListener('keydown', onEscKey)
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onEscKey)
})

return { __sfc: true,props, emit, proxy, companyId, companyGroupId, baseUrl, name, filter, saving, authConfig, apiErrorMessage, loadForm, save, onClose, onEscKey, CustomerFilterPanel }
}

})